import { theme } from '@clickcease/cc-client-components-lib'
export const wrapperCss = {
  height: '25px',
  '> div > div': {
    border: 'none',
    width: '100px',
    minWidth: '90px',
    '> div > div': {
      fontSize: theme.fontSizes.h3,
      fontWeight: theme.fontWeights.r,
      color: theme.colors.black.value,
    },
  },
}

export const wrapperMobileCss = {
  height: '25px',
  '> div > div': {
    border: 'none',
    width: '100px',
    minWidth: '90px',
    '> div > div': {
      fontSize: theme.fontSizes.lg,
      fontWeight: theme.fontWeights.r,
      color: theme.colors.black.value,
    },
  },
}
